import type { DSData } from 'webapp-types';

import type PopupContext from 'webapp/models-custom/popup/context';
import Serviced from 'webapp/models-custom/serviced';

export type AnomalyPointData = DSData.AnomalyExtraData & {
	name?: string;
	bgColor?: string;
	color?: string;
	text?: string;
};

export type GoalPointData = DSData.GoalPointExtraData;
export type PointOnClick = (event: PointerEvent, onClose?: () => void) => PopupContext | undefined;

export interface PointBaseData {
	granulationLabel?: DSData.GranulationLabel;
	value?: number | null;
	valueStr?: string;
	title?: string; // used for sorting on primaries
	anomalyData?: AnomalyPointData | null;
	goalData?: GoalPointData | null;
	onClick?: PointOnClick;
}

export default abstract class DChartPointBase extends Serviced {
	value: number | null = null;
	valueStr: string;
	granulationLabel: DSData.GranulationLabel;
	title: string;
	anomalyData: AnomalyPointData | null = null;
	goalData: GoalPointData | null = null;
	onClick?: PointOnClick;

	abstract get tooltipTypeClass(): string;

	constructor(pointData: PointBaseData) {
		super();

		if (typeof pointData.value === 'number') {
			this.value = pointData.value;
		}

		this.valueStr = pointData.valueStr || '-';

		if (pointData.granulationLabel) {
			this.granulationLabel = pointData.granulationLabel;
		} else {
			this.granulationLabel = {
				ts: 0,
				endTs: 0,
				label: '',
				labelShort: '',
				labelLong: '',
			};
		}

		this.title = pointData.title || '';

		if (pointData.anomalyData) {
			this.anomalyData = pointData.anomalyData;
		}

		if (pointData.goalData) {
			this.goalData = pointData.goalData;
		}

		if (pointData.onClick) {
			this.onClick = pointData.onClick;
		}
	}
}
